import { AirdropMementoIcon, ClaimIcon, LeftArrowIcon, MerchDropIcon, PollIcon } from "components/atoms/Icon";
import MagnetImageContainer from "components/atoms/images/MagnetImageContainer";
import { useRouter } from "components/hooks";

import { useState } from "react";

import DefaultImage from "../../../assets/Images/BrandImage1.png";
import FormExitConfirmationModal from "./FormExitConfirmationModal";

type Props = {
  magnetName: string;
  magnetImageUrl: string;
  brandName: string;
  isDirty: boolean;
  activationType: "merchDrop" | "airDrop" | "poll" | "claimCode" | "shareRequest";
  children: JSX.Element | JSX.Element[];
};

const activationData = {
  merchDrop: {
    icon: <MerchDropIcon />,
    heading: "MerchDrop",
  },
  poll: {
    icon: <PollIcon />,
    heading: "Community Poll",
  },
  claimCode: {
    icon: <ClaimIcon />,
    heading: "Claim Code Memento",
  },
  airDrop: {
    icon: <AirdropMementoIcon />,
    heading: "Airdrop Memento",
  },
  shareRequest: {
    icon: <AirdropMementoIcon />,
    heading: "Share Request",
  },
};

function FormLayoutWithModal({ magnetName, magnetImageUrl, brandName, isDirty, activationType, children }: Props) {
  const router = useRouter();

  const [isExitConfirmationModalOpen, setIsExitConfirmationModalOpen] = useState(false);

  const navigateToPreviousPage = () => {
    router.go(-1);
  };

  const handleBackButtonClick = () => {
    if (isDirty) setIsExitConfirmationModalOpen(true);
    else navigateToPreviousPage();
  };

  const onExitModalClose = () => {
    setIsExitConfirmationModalOpen(false);
  };

  return (
    <>
      {isExitConfirmationModalOpen && (
        <FormExitConfirmationModal onModalClose={onExitModalClose} handleContinueButtonClick={navigateToPreviousPage} />
      )}
      <div className="mt-3 font-sora">
        <div className="main-container min-h-[80vh]">
          <div className="flex">
            <div>
              <button type="button" className="" onClick={handleBackButtonClick}>
                <LeftArrowIcon className="h-4 w-6 2xl:h-6 2xl:w-9" />
              </button>
            </div>
            <div className="ml-3 grow space-y-2 2xl:ml-4 2xl:space-y-4">
              <div className="flex space-x-3 2xl:space-x-5">
                <div className="h-20 w-20 rounded-xl border border-white 2xl:h-24 2xl:w-24">
                  <MagnetImageContainer image={magnetImageUrl || DefaultImage} altText={magnetName} />
                </div>
                <div className="mt-1">
                  <div className="flex space-x-1 2xl:space-x-2">
                    {activationData[activationType].icon}
                    <p className="font-satoshi text-xs font-semibold leading-5 text-white 2xl:text-sm">
                      {activationData[activationType].heading}
                    </p>
                  </div>
                  <p className="mt-0 font-satoshi text-2xl font-bold leading-10 text-white 2xl:mt-2 2xl:text-3xl">
                    {magnetName}
                  </p>
                  <p className="font-satoshi text-xxs font-semibold leading-5 text-white text-opacity-70 2xl:text-xs">
                    {brandName}
                  </p>
                </div>
              </div>
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default FormLayoutWithModal;
